import React, { useState, useEffect } from 'react'
import { doc, getDoc } from 'firebase/firestore';
import init from '../../firebase';

const UserNameFinder = ({ user_id }) => {
    const [name, setName] = useState('');
// console.log(name)
    const nameFinder = async () => {
        try {
            const mycollection = doc(init.db, 'users',user_id);
            const res = await getDoc(mycollection);
            setName(res.data().name)
        } catch (error) {
            console.log(`Error : ${error}`)
        }
    }
    useEffect(() => {
        if(!user_id) return
        nameFinder()
    }, [user_id])
    return (
        <span>{`${name !== '' ? name : 'Unknown'}`}</span>
    )
}

export default UserNameFinder